import {createSlice} from '@reduxjs/toolkit';

interface SaveReminderNotificationProps {
  show: boolean;
}

const initialState: SaveReminderNotificationProps = {
  show: false,
};

const saveReminderSlice = createSlice({
  name: 'messageGrowl',
  initialState,
  reducers: {
    showSaveReminder: (state) => {
      state.show = true;
    },
    hideSaveReminder: (state) => {
      state.show = false;
    },
  },
});

export const {showSaveReminder, hideSaveReminder} = saveReminderSlice.actions;
export const saveReminderReducer = saveReminderSlice.reducer;
